import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import APIService from '../../Service/APIService';
import { Row, Col, Input, Upload, message, Button, Modal, Flex, Spin } from 'antd';
import CustomHeader from '../CustomHeader/CustomHeader';
import "./IVRCss.css";
import Select from 'react-select';
import { InboxOutlined, LoadingOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { set } from 'date-fns';
import { useAuth } from '../AuthProvider.js';


const ViewIVRManufacturer = () => {
  const { user } = useAuth();
  const userData = user;
  const params = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(true);
  const [ivrData, setIvrData] = React.useState(null);
  // const [manufacturerData, setManufacturerData] = React.useState(null);
  const [manufacturerOptions, setManufacturerOptions] = React.useState([]);
  const [selectedManufacturer, setSelectedManufacturer] = React.useState(null);
  const [caseID, setCaseID] = React.useState("");
  const [insuranceStatus, setInsuranceStatus] = React.useState(null);
  const [infoRequiredComments, setInfoRequiredComments] = React.useState(null);
  const [ivrReport, setIvrReport] = React.useState(null);
  const [fileName, setFileName] = React.useState(null);
  const [isEditable, setIsEditable] = React.useState(false);
  const [uploadFileList, setUploadFileList] = React.useState([]);
  const [isFileUpdated, setIsFileUpdated] = React.useState(false);
  const [azureBlobName, setAzureBlobName] = React.useState(null);

  const handleFile = async ({ file, onSuccess }) => {
    console.log("Custom request called", file);
    if (file.size > 4194304) {
      message.error("File size should be less than 4MB");
      setFileName(null);
      setIvrReport(null);
      setUploadFileList([]);
      return;
    }
    setIsFileUpdated(true);
    let fileName = file.name;
    const sanitizedBlobName = fileName.replace(/\s+/g, '_');
    setFileName(sanitizedBlobName);
    setUploadFileList([{ name: sanitizedBlobName, status: 'done', uid: '1' }]);
    setIvrReport(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  }

  const downloadFile = async () => {

    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(azureBlobName);
    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }

    // download the file from Azure Blob Storage
    const link = document.createElement('a');
    link.href = sasUrl;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // console.log("Download File: ", ivrReport);
    // const url = window.URL.createObjectURL(ivrReport);

    // // Create a link element and trigger the download
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", fileName); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  }

  const uploadProps = {
    name: 'file',
    multiple: false,
    // action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    accept: ['.pdf'],
    disabled: !isEditable,
    // defaultFileList: ivrReport ? [{ name: fileName, status: 'done', uid: '1' }] : [],
    fileList: uploadFileList,
    // onDownload: downloadFile,
    onPreview: downloadFile,
    customRequest: handleFile,
    onRemove: (file) => {
      setIvrReport(null);
      setUploadFileList([]);
      setFileName(null);
    },
    onChange(info) {
      console.log("Info: ", info);
      const { status } = info.file;
      console.log("Status: ", status);
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        // setIvrReport(info.file.originFileObj);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const getIVRManufacturerById = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getivrmanufacturerbyid?ID=${params.id}`
    );
    console.log("IVR Manufacturer Data: ", response?.data?.data);
    if (response?.data?.data?.AzureBlobName) {
      // const arrayBuffer = response?.data?.data?.UploadedFile.data;
      // const bytes = new Uint8Array(arrayBuffer);
      // const blob = new Blob([bytes], { type: "application/pdf" });
      setUploadFileList([{ name: response?.data?.data?.FileName, status: 'done', uid: '1' }]);
      // setIvrReport(blob);
      setFileName(response?.data?.data?.FileName);
      setAzureBlobName(response?.data?.data?.AzureBlobName);
    }
    setCaseID(response?.data?.data?.CaseID);
    setInfoRequiredComments(response?.data?.data?.InfoRequiredComments);
    setInsuranceStatus({
      label: response?.data?.data?.InsuranceStatus,
      value: response?.data?.data?.InsuranceStatus
    });
    setSelectedManufacturer({
      label: response?.data?.data?.ManufacturerName,
      value: response?.data?.data?.ManufacturerID
    });
    const ivrID = response?.data?.data?.IVRID;
    getIvrById(ivrID).then((data) => {

      setIvrData(data);
    });
    setIsLoading(false);
  }

  const getIvrById = async (ivrID) => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getivrbyid?ID=${ivrID}`
    );
    console.log("IVR Data: ", response?.data?.data);
    // setIvrData(response?.data?.data);
    const tempIvr = response?.data?.data;
    // get manufacturers from account
    const manufacturers = await apiServe.getDataFromBackend(`getmanufacturersfromaccount?ID=${tempIvr?.AccountID}`);
    // console.log("Manufacturers: ", manufacturers?.data?.data);
    let manOptions = [];
    manufacturers?.data?.data?.forEach((item) => {
      manOptions.push({
        label: item.ManufacturerName,
        value: item.ID
      });
    })
    setManufacturerOptions(manOptions);
    return response?.data?.data
  }

  const handleSubmit = async (type) => {
    // console.log("selectedManufacturer: ", selectedManufacturer);
    setIsLoading(true);
    let isValid = true;
    const apiServe = new APIService();
    let postObj = {
      ID: params?.id,
      ivrID: ivrData.ID,
      accountID: ivrData.AccountID,
      accountName: ivrData.AccountName,
      manufacturerID: selectedManufacturer?.value,
      manufacturerName: selectedManufacturer?.label,
      caseID: caseID,
      insuranceStatus: insuranceStatus?.value,
      infoRequiredComments: infoRequiredComments,
      isFileUpdated: isFileUpdated,
      type: type
    }
    const stringifiedPostObj = JSON.stringify(postObj);
    console.log("Post Object: ", postObj);
    console.log("file: ", ivrReport);
    const formData = new FormData();
    formData.append('file', ivrReport);
    formData.append('data', stringifiedPostObj);

    if (!selectedManufacturer || !caseID || !insuranceStatus) {
      isValid = false;
    }
    // if (insuranceStatus?.value != 'Submitted') {
    //   message.error("Please upload IVR Report");
    //   return;
    // }
    if (isValid === false) {
      Swal.fire(
        'Error!',
        'Please fill all the fields',
        'error'
      );
      return;
    }

    // const response = await apiServe.addDataToBackend(postObj, 'updateivrmanufacturer');
    const response = await apiServe.addFileDataToBackend(formData, 'updateivrmanufacturer', {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    });
    console.log("Update IVR Manufacturer Response: ", response);
    if (response?.status === 200 || response?.status === 201) {
      Swal.fire(
        'Updated!',
        'IVR Manufacturer data has been updated.',
        'success'
      ).then(() => {
        window.location.reload();
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Error in submitting IVR Manufacturer data.',
        'error'
      )
      setIsLoading(false);
    }
    setIsLoading(false);
  }

  const handleButtonClick = () => {
    if (isEditable) {
      // handleSubmit(); // Trigger form submission
      setShowSubmitModal(true); // Show confirmation modal
    } else {
      // setUploadFileList([]);
      setIsEditable(true); // Enable edit mode
    }
  };

  React.useEffect(() => {
    console.log("View IVR Manufacturer");
    console.log("IVR Manufacturer ID ", params.id);
    if (userData?.Type === "Account" && !userData?.EnableIVR) {
      navigate('/');
    }
    // if(userData?.Type === "Manufacturer") {
    //   navigate('/');
    // }
    getIVRManufacturerById();
  }, []);

  // const downloadFromBlobStorage = async () => {
  //   const apiServe = new APIService();
  //   const response = await apiServe.getDataFromBackend("getsastoken");
  //   console.log("SAS Token Response: ", response?.data?.data);
  //   const link = document.createElement('a');
  //   link.href = response?.data?.data;
  //   link.download = 'test'; // Optional: provide filename
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }

  const [showSubmitModal, setShowSubmitModal] = React.useState(false);

  const handleSaveAndNotify = async () => {
    setShowSubmitModal(false);
    await handleSubmit('notify');
  }
  const handleSave = async () => {
    setShowSubmitModal(false);
    await handleSubmit('dontNotify');
  }


  return (
    <div>
      {isLoading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      <CustomHeader leftTopText="Welcome back!" leftBottomText="IVRAS ID" leftBottomExtraText={ivrData?.IVRASID} rightTopText="Logged in as Admin" rightBottomText="User" />
      {userData?.Type === 'Admin' &&
        <Button
          type="primary"
          style={{ marginBottom: 16, background: isEditable ? '#27a907' : '#ff9202' }}
          onClick={() => handleButtonClick()}
        >
          {isEditable ? 'Save Changes' : 'Edit'}
        </Button>
      }
      {/* <Button type="primary" onClick={async () => downloadFromBlobStorage()} style={{ background: '#27a907', marginRight: '16px' }}>Download </Button> */}
      <Row gutter={16}>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Manufacturer: </label>
          <Select
            style={{ width: '100%' }}
            options={manufacturerOptions}
            onChange={(value) => { setSelectedManufacturer(value) }}
            isDisabled={!isEditable}
            // defaultValue={selectedManufacturer}
            value={selectedManufacturer}
          />
        </Col>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Case ID: </label>
          <Input
            name="CaseID"
            value={caseID}
            onChange={(e) => setCaseID(e.target.value)}
            defaultValue={caseID}
            disabled={!isEditable}
          />
        </Col>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Insurance Status</label>
          <Select
            style={{ width: '100%' }}
            options={[
              { label: 'Submitted', value: 'Submitted' },
              { label: 'Not Covered', value: 'Not Covered' },
              { label: 'Covered', value: 'Covered' },
              { label: 'Info Required', value: 'Info Required' }
            ]}
            onChange={(value) => setInsuranceStatus(value)}
            isDisabled={!isEditable}
            value={insuranceStatus}
          />
        </Col>

        {insuranceStatus?.value === 'Info Required' &&
          <Col span={6} style={{ width: '100%' }}>
            <label className="form-label">Info Required: </label>
            <Input
              name="InfoRequiredComments"
              value={infoRequiredComments}
              onChange={(e) => setInfoRequiredComments(e.target.value)}
              defaultValue={infoRequiredComments}
              disabled={!isEditable}
            />
          </Col>
        }
      </Row>
      {ivrData &&
        <>
          <Row gutter={16} style={{ marginTop: '20px' }}>
            <Col span={24} style={{ width: '100%' }}>
              <label className="form-label">IVR Report</label>
              <p className='input-subtitle'>Upload IVR Report is sent by the Manufacturer</p>
              <Upload.Dragger {...uploadProps}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Drag or click to upload file</p>
                <p className="ant-upload-hint">
                  Accepted format: PDF (Max file size limit: 4MB)
                </p>
              </Upload.Dragger>
            </Col>
          </Row>
        </>
      }
      <div>
        <Modal
          title="Updating IVR Manufacturer"
          open={showSubmitModal}
          footer={false}
          onCancel={() => setShowSubmitModal(false)}
        >
          <p>
            Are you sure you want to update the IVR Manufacturer? This will notify related users about this status change via email.

            {insuranceStatus?.value === 'Info Required' &&
              <>
                <label className="form-label">Info Required Comments: </label>
                <Input
                  name="InfoRequiredComments"
                  value={infoRequiredComments}
                  onChange={(e) => setInfoRequiredComments(e.target.value)}
                  defaultValue={infoRequiredComments}
                />
              </>
            }
            <Row gutter={16} style={{ marginTop: '20px' }}>
              <Col span={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Button type="primary" onClick={async () => await handleSaveAndNotify()} style={{ background: '#27a907' }}>
                  Save and Notify
                </Button>
              </Col>
              <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" onClick={async () => await handleSave()} style={{ background: '#ff9202' }}>
                  Don't Notify
                </Button>
              </Col>
            </Row>
          </p>
        </Modal>
      </div>
    </div>
  )
}

export default ViewIVRManufacturer;